import PriceValueETF from './PriceValueETF';

export default PriceValueETF;
